<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_5"></a><em>To Gwendolyn, my wife,<br/>who makes me want to be good.<br/>And to Mary Kate, my daughter,<br/>who makes me want to be great</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?ead03f78